const normalizePath = (path: string) => path.replace(/\/$/, '');

const previewRoutes = new Set(
  ((import.meta.env.VITE_PERMISSION_PREVIEW_ROUTES as string | undefined) ?? '')
    .split(',')
    .map((path) => normalizePath(path.trim()))
    .filter(Boolean),
);

export function isFrontendPreviewRoute(path: string) {
  const clean = normalizePath(path);

  for (const previewRoute of previewRoutes) {
    if (clean === previewRoute || clean.startsWith(`${previewRoute}/`)) return true;
  }

  return false;
}
